<div class="profile-container">
  <div class="profile-card">
    <div class="profile-header">
      <div class="avatar-section">
        <div class="avatar-container">
          <img *ngIf="user.logo" [src]="user.logo" alt="Avatar" class="avatar-img">
          <div *ngIf="!user.logo" class="avatar-initials">
            {{ initials || '?' }}
          </div>
          <button class="edit-avatar" title="Şəkli dəyiş">
            <i class="icon-camera"></i>
          </button>
        </div>
        <div class="profile-title">
          <h3>{{ user.name || 'İstifadəçi' }}</h3>
          <p class="profile-subtitle">{{ user.email }}</p>
        </div>
      </div>
      <div class="header-actions">
        <span class="status-badge" [class.active]="user.packetId">
          {{ user.packetId ? 'Premium Hesab' : 'Standart Hesab' }}
        </span>
      </div>
    </div>

    <div class="profile-content">
      <form #profileForm="ngForm" (ngSubmit)="saveProfile()" class="profile-form">
        <div class="form-grid">
          <div class="form-group">
            <label for="name">Ad</label>
            <div class="input-wrapper">
              <i class="icon-user"></i>
              <input type="text" id="name" [(ngModel)]="user.name" name="name" class="form-control" placeholder="Adınız">
            </div>
          </div>

          <div class="form-group">
            <label for="email">E-poçt ünvanı</label>
            <div class="input-wrapper">
              <i class="icon-mail"></i>
              <input
                type="email"
                id="email"
                [(ngModel)]="user.email"
                name="email"
                class="form-control"
                placeholder="Email"
                #emailModel="ngModel"
                [class.is-invalid]="emailModel.invalid && emailModel.touched"
                pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
              >
              <div class="error-message" *ngIf="emailModel.invalid && emailModel.touched">
                Zəhmət olmasa düzgün e-poçt ünvanı daxil edin
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="phone">Telefon</label>
            <div class="input-wrapper disabled">
              <i class="icon-phone"></i>
              <input
                type="text"
                id="phone"
                [(ngModel)]="user.phone"
                name="phone"
                class="form-control"
                placeholder="+994 (0XX) XXX-XX-XX"
                readonly
              >
            </div>
          </div>

          <div class="form-group">
            <label for="password">Şifrə</label>
            <div class="input-wrapper">
              <i class="icon-lock"></i>
              <input
                id="password"
                [type]="showPassword ? 'text' : 'password'"
                [(ngModel)]="user.password"
                name="password"
                class="form-control"
                placeholder="••••••••"
              >
              <button type="button" class="toggle-password" (click)="togglePasswordVisibility()" [title]="showPassword ? 'Gizlə' : 'Göstər'">
                <i class="icon" [class.icon-show]="!showPassword" [class.icon-hide]="showPassword"></i>
              </button>
            </div>
          </div>

          <div class="form-group full-width" *ngIf="user.description !== undefined">
            <label for="description">Haqqınızda</label>
            <div class="input-wrapper">
              <i class="icon-info"></i>
              <textarea
                id="description"
                [(ngModel)]="user.description"
                name="description"
                class="form-control"
                rows="4"
                placeholder="Özünüz barədə qısa məlumat..."
              ></textarea>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-save">
            Yadda saxla
          </button>
          <button type="button" class="btn-delete-outline" (click)="confirmDelete()">
            Hesabı sil
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal-overlay" *ngIf="showDeleteModal">
  <div class="modal-content">
    <h4>Hesabı sildiyinizə əminsiniz?</h4>
    <div class="modal-actions">
      <button class="btn-yes" (click)="closeModal()">Hə</button>
      <button class="btn-no" (click)="closeModal()">Yox</button>
    </div>
  </div>
</div>
